import { createAction, props } from '@ngrx/store';
import { FeatureMapUserAccount } from '../../../admin/interfaces/user-accout.interface';

export enum AccountActionTypes {
    LoadAccountFeatures = '[AccountFeature] Load Account Feature',
    LoadAccountFeaturesFinished = '[AccountFeature] Load Account Finished',
    CleanAccountFeatures = '[AccountFeature] Clean Account Feature'
}

export const loadAccountFeature = createAction(AccountActionTypes.LoadAccountFeatures, props<{ customerId: string }>());

export const loadAccountFeaturesFinished = createAction(AccountActionTypes.LoadAccountFeaturesFinished, props<{ accountFeatures: FeatureMapUserAccount | null }>());

export const cleanAccountFeature = createAction(AccountActionTypes.CleanAccountFeatures);
